<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" lg="6" sm="12">
                <v-card>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon>mdi-check-decagram</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">権限情報編集</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                    <v-form ref="permission_master_form" v-model="valid" @submit.prevent>
                        <v-text-field label="権限名称" v-model="permissionName" :rules="permissionNameRules" dense outlined>
                            <template v-slot:append>
                                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                            </template>
                        </v-text-field>
                        <v-divider class="mb-5"/>
                        <v-btn class="mb-5 mr-3" color="success" @click="allCheck(true)" depressed>すべて選択する</v-btn>
                        <v-btn class="mb-5" color="error" @click="allCheck(false)" depressed>すべて選択をはずす</v-btn>
                        <v-row no-gutters v-for="item in functions" :key="item.id">
                            <v-col cols="12">
                                <header>{{ item.function_name }}</header>
                            </v-col>
                            <v-checkbox v-if="permissions[item.function_code].visible_read" v-model="permissions[item.function_code].read" class="mx-2" color="success" label="閲覧"></v-checkbox>
                        <v-checkbox v-if="permissions[item.function_code].visible_update" v-model="permissions[item.function_code].update" class="mx-2" color="success" label="作成/編集"></v-checkbox>
                        <v-checkbox v-if="permissions[item.function_code].visible_delete" v-model="permissions[item.function_code].delete" class="mx-2" color="success" label="削除"></v-checkbox>
                        <v-checkbox v-if="permissions[item.function_code].visible_display" v-model="permissions[item.function_code].display" class="mx-2" color="success" label="全データ表示"></v-checkbox>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'PermissionMaster' }" depressed>キャンセル</v-btn>
                    <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
                </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="dialogDrawer" persistent :max-width="dialogMaxWith">
                <v-card>
                    <v-card-title class="headline">{{dialogTitle}}</v-card-title>
                    <v-card-text>
                        <v-divider/>
                        <v-data-table :headers="dialogHeaders" :items="dialogItems" hide-default-footer disable-pagination dense/>
                        <v-divider/>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="grey lighten-1" @click.stop="dialogCancel">キャンセル</v-btn>
                        <v-btn depressed color="warning" @click.stop="submit">更新</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import Rule from "@/validation/rules";
  import PermissionsApi from "@/api/permissions-api";

  export default {
        name: "PermissionMasterEdit",
        data: () => ({
            loading: false,
            permissionName: "",
            permissions: {},
            functions: {},
            editId: null,

            // 更新ダイアログ
            dialogHeaders: [
                { text: "画面名", value: "name" },
                { text: "閲覧", value: "read", align: "center" },
                { text: "作成/編集", value: "update", align: "center" },
                { text: "削除", value: "delete", align: "center" },
                { text: "全データ表示", value: "display", align: "center" }
            ],
            dialogMaxWith: 600,
            dialogTitle: "",
            dialogItems: [],
            dialogDrawer: false,

            // バリデーション
            valid: true,
            permissionNameRules: Rule.permissionNameRules
        }),
        created() {
            this.initialize();
        },
        methods: {
            isLoading() {
                this.loading = !this.loading;
                this.$emit("loading", this.loading);
            },
            initialize () {
                this.isLoading();
                this.permissionsApi = new PermissionsApi();
                this.editId = this.$route.params.id;
                const promise = this.permissionsApi.info(this.editId);
                promise.then(response => {
                    this.functions = response.data.body.function_list;
                    this.permissionName = response.data.body.permission_info.permission_name;
                    this.permissions = response.data.body.permission_info.config;
                    for (var item of response.data.body.function_list) {
                        if (!(item.function_code in this.permissions)) {
                            this.permissions[item.function_code] = {
                                name: item.function_name,
                                visible_read: true,
                                visible_update: true,
                                visible_delete: true,
                                visible_display: false,
                                read: false,
                                update: false,
                                delete: false,
                                display: false
                            };
                        }
                        this.permission_change(this.permissions[item.function_code])
                    }
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if(error.response){
                        this.$emit("error",error.response.data.message);
                    }else{
                        this.$emit("error","サーバーエラーが発生しました。");
                    }
                }).finally(() => {
                    this.isLoading();
                });
            },
            permission_change(obj) {
                if (obj.name == "企業情報") {
                    obj.visible_delete = false
                }
                if (obj.name == "プロフィール") {
                    obj.visible_delete = false
                }
                if (obj.name == "企業情報") {
                    obj.visible_delete = false
                }
                if (obj.name == "工事情報") {
                    obj.visible_display = true
                }
                if (obj.name == "実行予算書") {
                    obj.visible_delete = false
                }
                if (obj.name == "作業日報") {
                    obj.visible_delete = false
                }
                if (obj.name == "工事日報") {
                    obj.visible_display = true
                    obj.visible_delete = false
                }
                if (obj.name == "分析情報") {
                    obj.visible_update = false
                    obj.visible_delete = false
                }
                if (obj.name == "作業日報一括修正") {
                    obj.visible_delete = false
                }
                if (obj.name == "作業日報(経費)一括修正") {
                    obj.visible_delete = false
                }
            },
            allCheck(isCheck) {
                for (var key in this.permissions) {
                    if (this.permissions[key].visible_read) {
                        this.permissions[key].read = isCheck
                    }
                    if (this.permissions[key].visible_update) {
                        this.permissions[key].update = isCheck
                    }
                    if (this.permissions[key].visible_delete) {
                        this.permissions[key].delete = isCheck
                    }
                    if (this.permissions[key].visible_display) {
                        this.permissions[key].display = isCheck
                    }
                }
                for (var item of this.$refs.permission_master_form.inputs) {
                    if ("inputValue" in item) {
                        item.inputValue = isCheck
                    }
                }
            },
            checkDialog() {
                this.dialogTitle = "権限[" +this.permissionName + "]を更新しますか？";
                this.dialogItems = [];
                for (var key in this.permissions) {
                    this.dialogItems.push({
                        name: this.permissions[key].name,
                        read: this.permissions[key].read ? "✔" : "",
                        update: this.permissions[key].update ? "✔" : "",
                        delete: this.permissions[key].delete ? "✔" : "",
                        display: this.permissions[key].display ? "✔" : ""
                    });
                }
                this.dialogDrawer = true;
            },
            dialogCancel() {
                this.dialogDrawer = false;
            },
            submit() {
                if (this.$refs.permission_master_form.validate()) {
                    this.isLoading();
                    const promise = this.permissionsApi.update(this.editId, {
                        name: this.permissionName,
                        config: JSON.stringify(this.permissions)
                    });
                    promise.then((response) => {
                        this.$emit('success', response.data.message);
                        this.$router.push({ name: 'PermissionMaster' });
                    }).catch(error => {
                        useAppInsights().trackException({exception: error});
                        if(error.response){
                            this.$emit("error",error.response.data.message);
                        }else{
                            this.$emit("error","サーバーエラーが発生しました。");
                        }
                    }).finally(() => {
                        this.isLoading();
                    });
                }
            }
        }
    };
</script>
